(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bungeroth-aroma-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bung-aroma-help')) {
  customElements.define('bung-aroma-help', class extends HTMLElement {
    connectedCallback() {
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      if (!details || !summary || this.dataset.ready) return;
      this.dataset.ready = 'true';
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        details.open = !details.open;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bungeroth-pack-trust"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bung-pack-trust')) {
  customElements.define('bung-pack-trust', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const scope = this.closest('.product-details');
      this.quote = this.querySelector('.bung-client-quote');
      const placeQuote = () => {
        const button = scope?.querySelector('#buttonContainerProduct #rsi_buy_now_button');
        if (button && this.quote && button.previousElementSibling !== this.quote) {
          button.before(this.quote);
        }
      };
      if (scope && this.quote) {
        this.observer = new MutationObserver(() => {
          if(this.frame)return;
          this.frame=requestAnimationFrame(()=>{
            this.frame=0;
            this.observer.disconnect();
            placeQuote();
            if(this.isConnected)this.observer.observe(scope,{childList:true,subtree:true});
          });
        });
        this.observer.observe(scope, { childList: true, subtree: true });
        placeQuote();
      }
      this.querySelectorAll('details').forEach(details => details.querySelector('summary')?.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        details.open = !details.open;
      }));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame=0;
      this.observer?.disconnect();
      this.quote?.remove();
      this.ready = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bungeroth-pack-videos"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bung-ugc-videos')){
customElements.define('bung-ugc-videos',class extends HTMLElement{
 connectedCallback(){
  if(this.observer)return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clips=[...this.querySelectorAll('video')];
  this.posterObserver=new IntersectionObserver(entries=>{
   entries.forEach(({target:v,isIntersecting})=>{
    if(!isIntersecting)return;
    v.poster=v.dataset.poster;
    this.posterObserver.unobserve(v);
   });
  },{rootMargin:'300px 0px'});
  clips.forEach(v=>this.posterObserver.observe(v));
  this.observer=new IntersectionObserver(entries=>{
   entries.forEach(({target:v,isIntersecting,intersectionRatio})=>{
    if(isIntersecting&&intersectionRatio>=.6){
     if(!v.src){v.src=v.dataset.src;v.load();}
     if(!reduced){v.muted=true;v.play().catch(()=>{});}
    }else if(!v.paused){v.pause();}
   });
  },{threshold:[0,.6]});
  clips.forEach(v=>this.observer.observe(v));
  this.visibilityHandler=()=>{if(document.hidden)clips.forEach(v=>v.pause());};
  document.addEventListener('visibilitychange',this.visibilityHandler);
 }
 disconnectedCallback(){this.posterObserver?.disconnect();this.observer?.disconnect();this.observer=null;document.removeEventListener('visibilitychange',this.visibilityHandler);}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bungeroth-selection-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bung-selection-help')) customElements.define('bung-selection-help', class extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;
    this.ready=true;
    const scope=this.closest('.product-details');
    if(!scope)return;
    const guide=this.querySelector('.bung-selection-instruction');
    const note=this.querySelector('.bung-selection-next');
    const dialog=this.querySelector('dialog');
    const selects=()=>Array.from(scope.querySelectorAll('#buttonContainerProduct .rsi-variant-picker-select')).filter(e=>e.getClientRects().length);
    const button=()=>scope.querySelector('#buttonContainerProduct #rsi_buy_now_button');
    let bypass=false;
    const update=()=>{
      const fields=selects(),cta=button();
      if(!fields.length){guide.hidden=true;note.hidden=true;return;}
      const first=fields[0].closest('.rsi-variant-picker-wrapper');
      if(first.previousElementSibling!==guide)first.before(guide);
      guide.hidden=false;
      fields.forEach((field,i)=>{
        const label=this.dataset.perfume+' '+(i+1);
        const number=field.closest('.rsi-variant-picker-wrapper')?.querySelector('.rsi-variant-picker-vn');
        if(number && number.textContent!==label)number.textContent=label;
        if(field.getAttribute('aria-label')!==label)field.setAttribute('aria-label',label);
      });
      const text=cta?.querySelector('div > div');
      if(text && text.textContent!==this.dataset.cta)text.textContent=this.dataset.cta;
      if(cta && cta.nextElementSibling!==note)cta.after(note);
      note.hidden=false;
    };
    this.clickHandler=event=>{
      if(!event.target.closest('#buttonContainerProduct #rsi_buy_now_button'))return;
      const fields=selects();
      if(bypass){bypass=false;return;}
      if(fields.length<2 || !fields.every(e=>e.value===fields[0].value))return;
      event.preventDefault();event.stopImmediatePropagation();
      const aroma=fields[0].selectedOptions[0].textContent.trim();
      dialog.querySelector('.bung-selection-summary').textContent=fields.length+' × '+aroma;
      dialog.showModal();
      dialog.querySelector('.bung-selection-review').focus();
    };
    scope.addEventListener('click',this.clickHandler,true);
    dialog.querySelector('.bung-selection-review').addEventListener('click',()=>{dialog.close();const first=selects()[0];first?.scrollIntoView({block:'center',behavior:'auto'});first?.focus();});
    dialog.querySelector('.bung-selection-accept').addEventListener('click',()=>{dialog.close();bypass=true;button()?.click();bypass=false;});
    this.observer=new MutationObserver(()=>{
      if(this.frame)return;
      this.frame=requestAnimationFrame(()=>{
        this.frame=0;
        this.observer.disconnect();
        update();
        if(this.isConnected)this.observer.observe(scope,{childList:true,subtree:true});
      });
    });
    this.observer.observe(scope,{childList:true,subtree:true});
    this.scope=scope;this.guide=guide;this.note=note;
    update();
  }
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.frame=0;this.observer?.disconnect();this.scope?.removeEventListener('click',this.clickHandler,true);this.guide?.remove();this.note?.remove();this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

})();
